<template>
  <div>
    <div class="callme_total_wrap hidden-xs-only">
      <div class="callme_total_wrap_left">
        <div class="callme_total_wrap_left_top">江苏厚添</div>
        <div class="callme_total_wrap_left_center">
          <div class="callme_total_wrap_left_center_item" @click="toPage('/hd/qywh')">
            <img src="./image/ptjs.png" alt="">平台介绍
          </div>
          <div class="callme_total_wrap_left_center_item" @click="toPage('/hd/lxwm')">
            <img src="./image/lxwm.png" alt="">联系我们
          </div>
          <div class="callme_total_wrap_left_center_item" @click="toPage('/wzdt')">
            <img src="./image/wzdt.png" alt="">网站地图
          </div>
        </div>
        <div class="callme_total_wrap_left_bottom">
          支持Chrome浏览器，最佳分辨率1920x1080
        </div>
      </div>
      <div class="callme_total_wrap_center"></div>
      <div class="callme_total_wrap_right">
        <div class="callme_total_wrap_right_item">
          <div class="callme_total_wrap_right_item_top">首页</div>
        </div>
        <div class="callme_total_wrap_right_item">
          <div class="callme_total_wrap_right_item_top">项目</div>
          <div class="callme_total_wrap_right_item_s" @click="toPage('/xm/zczr')">资产转让</div>
          <div class="callme_total_wrap_right_item_s" @click="toPage('/xm/zczl')">资产租赁</div>
          <div class="callme_total_wrap_right_item_s" @click="toPage('/xm/zhjy')">综合交易</div>
          <div class="callme_total_wrap_right_item_s" @click="toPage('/xm/nccq')">农村产权</div>
          <!-- <div class="callme_total_wrap_right_item_s" @click="toPage('/xm/gsdt')">项目推介</div> -->
          <div class="callme_total_wrap_right_item_s" @click="toPage('/xm/ygzb')">阳光招标</div>
          <div class="callme_total_wrap_right_item_s" @click="toPage('/xm/zstj')">招商推介</div>
          <div class="callme_total_wrap_right_item_s" @click="toPage('/xm/cjgs')">成交公示</div>
        </div>
        <div class="callme_total_wrap_right_item">
          <div class="callme_total_wrap_right_item_top">竞价</div>
          <div class="callme_total_wrap_right_item_s" @click="toPage('/jj/zcfg/4')">政策法规</div>
          <div class="callme_total_wrap_right_item_s" @click="toPage('/jj/jylc/5')">交易流程</div>
          <div class="callme_total_wrap_right_item_s" @click="toPage('/jj/jjxz/6')">竞价须知</div>
          <div class="callme_total_wrap_right_item_s" @click="toPage('/jj/wjxz/7')">文件下载</div>
        </div>
        <div class="callme_total_wrap_right_item">
          <div class="callme_total_wrap_right_item_top">互动</div>
          <div class="callme_total_wrap_right_item_s" @click="toPage('/hd/qywh')">企业文化</div>
          <div class="callme_total_wrap_right_item_s" @click="toPage('/hd/lxwm')">联系我们</div>
          <!-- <div class="callme_total_wrap_right_item_s" @click="toPage('/hd/zxzx')">在线咨询</div> -->
        </div>
        <div class="callme_total_wrap_right_item">
          <div class="callme_total_wrap_right_item_top">资讯</div>
          <div class="callme_total_wrap_right_item_s" @click="toPage('/zx/gsdt/1')">公司动态</div>
          <div class="callme_total_wrap_right_item_s" @click="toPage('/zx/hyzx/2')">行业资讯</div>
          <div class="callme_total_wrap_right_item_s" @click="toPage('/zx/tzgg/3')">通知公告</div>

        </div>
        <div class="callme_total_wrap_right_item">
          <div class="callme_total_wrap_right_item_top">特色服务</div>
        </div>
      </div>
    </div>
    <div class="ba_box">
      备案号 <span class="ba_box_link" @click="openBa">苏ICP备2024144405号-1</span>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {
    openBa() {
      window.open('https://beian.miit.gov.cn/#/Integrated/index', '_blank')
    },
    toPage(path) {
      this.$router.push({
        path: path
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.callme_total_wrap {
  width: 100%;
  height: 310px;
  background: #172032;
  padding: 0 292px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;

  .callme_total_wrap_left {
    .callme_total_wrap_left_top {
      font-weight: bold;
      font-size: 22px;
      color: #FFFFFF;
      margin-top: 40px;
    }

    .callme_total_wrap_left_center {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      margin-top: 82px;

      .callme_total_wrap_left_center_item {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        font-weight: 400;
        font-size: 16px;
        color: rgba(255, 255, 255, 0.8);
        line-height: 15px;
        cursor: pointer;
        &+.callme_total_wrap_left_center_item {
          margin-left: 50px;
        }

        img {
          width: 18px;
          height: 18px;
          margin-right: 4px;
        }
      }
    }

    .callme_total_wrap_left_bottom {
      font-weight: 400;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.51);
      margin-top: 72px;
    }
  }

  .callme_total_wrap_center {
    width: 1px;
    height: 235px;
    border: 1px solid rgba(222, 222, 229, 0.21);
    margin-top: 50px;
    margin-left: 104px;
  }

  .callme_total_wrap_right {
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-top: 60px;

    .callme_total_wrap_right_item {
      flex: 1;
      color: #ffffff;

      .callme_total_wrap_right_item_top {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 10px;
      }

      .callme_total_wrap_right_item_s {
        font-weight: 400;
        font-size: 16px;
        color: rgba(255, 255, 255, 0.8);
        cursor: pointer;

        &+.callme_total_wrap_right_item_s {
          margin-top: 6px;
        }
      }

      &:first-child {
        margin-left: 70px;
      }
    }
  }
}

.ba_box {
  width: 1920px;
  height: 50px;
  background: #121927;
  font-weight: 400;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .ba_box_link {
    &:hover {
      color: #39b7ff;
      cursor: pointer;
    }
  }
}
</style>